<template>
  <div>
    {{ sectorLabel }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SectorCell",
  props: ["value", "row", "column"],
  computed: {
    ...mapGetters("enums", ["sectorsTypes"]),
    sectorLabel() {
      if (!this.sectorsTypes?.length) return "-";

      const sector = this.sectorsTypes.find((s) => s.value === this.value);

      if (!sector) return this.value || "-";

      const parent = this.sectorsTypes.find((s) => s.id === sector.parentId);

      return `${parent ? parent.value + " > " : ""}${sector.value}`;
    },
  },
};
</script>
